module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "sp-submitastory"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    attrs: {
      "id": "sp-position-0"
    }
  }, [_c('div', {
    staticClass: "sp-column"
  }, [_c('div', {
    staticClass: "sp-module"
  }, [_c('div', {
    staticClass: "sp-module-content"
  }, [_c('div', {
    staticClass: "custom"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "17px"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "padding-right": "5px",
      "padding-top": "5px"
    },
    attrs: {
      "src": "/static/img/icons/submit_story.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/submit"
    }
  }, [_vm._v("Submit an entry")])], 1)])])]), _vm._v(" "), (!_vm.isLoggedIn) ? _c('div', {
    staticClass: "sp-module"
  }, [_c('div', {
    staticClass: "sp-module-content"
  }, [_c('div', {
    staticClass: "custom"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "17px"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "padding-right": "5px",
      "padding-top": "5px"
    },
    attrs: {
      "src": "/static/img/icons/submit_story.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login?redirect=%2Fsubmissions"
    }
  }, [_vm._v("Sign in to Glossary")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
    staticClass: "sp-module"
  }, [_c('div', {
    staticClass: "sp-module-content"
  }, [_c('div', {
    staticClass: "custom"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "17px"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "padding-right": "5px",
      "padding-top": "5px"
    },
    attrs: {
      "src": "/static/img/icons/submit_story.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/submissions"
    }
  }, [_vm._v("Submissions")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
    staticClass: "sp-module"
  }, [_c('div', {
    staticClass: "sp-module-content"
  }, [_c('div', {
    staticClass: "custom"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "17px"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "padding-right": "5px",
      "padding-top": "5px"
    },
    attrs: {
      "src": "/static/img/icons/submit_story.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Logout")])])])])]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-520db868!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LinkBlock.vue
// module id = 163
// module chunks = 2